import React, { useState } from 'react';
import Axios from 'axios';
import * as bs from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import * as bi from 'react-icons/bi';

export default function MyDocuments() {

    const navigate = useNavigate();
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);

    useState(async () => {
        const url = `https://docsserver.onrender.com/sheets/getDocuments`;
        try
        {
            let result = await Axios.get(url);
            if(result.data)
            {
                // console.log(result.data);
                setDocuments(result.data);
                setLoading(false);
            }
            else
            {
                setLoading(true);
            }
        }
        catch(err)
        {
            //console.log(err);
        }

    }, [])  

    function OpenDocument(urlID)
    {
        navigate(`/document/${urlID}`);
    }

    function DeleteDocx(urlkey)
    {
        //console.log(urlkey);
    }

    return (
        <section className='mt-5 p-3'>
            <h1 className='text-3xl font-semibold'><span className='animate-pulse'>🚀</span> My Documents</h1>
            
            {loading?<div className="flex justify-center items-center space-x-2 mt-3">
                        <div className='w-fit'>
                            <p className='animate-bounce'>                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg></p>
                        <p>Loading</p>
                        </div>
                    </div>
                    :
                    <div className='p-5 flex flex-col justify-center items-center md:grid md:grid-cols-4 w-4/5 mx-auto'>
                {documents.length == 0?<p className='text-2xl'>🆕 Create a new Docx</p>:documents.map((item) => {
                    //console.log(documents);
                    return(
                        <div onClick={() => OpenDocument(item.urlkey)} key={item._id} className="w-fit border-2 border-slate cursor-pointer mt-5 md:ml-5">
                            <div className='bg-white border-b min-h-[180px] max-h-[200px] min-w-[150px] max-w-full flex items-center justify-center overflow-hidden'>
                                <div className='overflow-hidden p-2 blur'>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                </div>
                            </div>
                            <div className='flex flex-col justify-center align-middle items-start p-3'>
                                <p className='font-semibold text-lg'>{item.name}</p>
                                <div className='flex items-center'>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                    </svg>
                                    <p className='text-gray-500 text-[0.8em] ml-1'>Created on {item.dateCreated}</p>
                                    {/* <div className='relative group'>
                                        <bs.BsThreeDotsVertical size={30} className='ml-2 hover:bg-gray-100 transition-all p-1'/>

                                        <div onClick={() => DeleteDocx(item.urlkey)} className='absolute cursor-pointer right-0 top-[1.5em] hidden group-hover:block'>
                                            <p className='px-3 py-2 bg-slate-200 hover:bg-red-600 hover:text-white   flex justify-center align-middle items-center'>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>Delete</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>}
        </section>
    )
}
